<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <search v-on:download="onDownload" v-on:searching="onSearch"></search>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-checkbox
                hide-details
                label="Enviar correos"
                primary
                v-model="form.sendEmails"
              ></v-checkbox>
              <v-btn @click="handlePayment()" color="success">pagar</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-toolbar card color="white">
              <b>Tienes {{ form.invoices.length }} facturas seleccionadas.</b>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="invoices"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
                v-model="complex.selected"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">
                    <v-checkbox
                      :disabled="props.item.liquidated == 'YES' ? true : false"
                      hide-details
                      primary
                      v-model="props.selected"
                    ></v-checkbox>
                  </td>
                  <td class="text-sm-left">{{ props.item.invoiceNumber }}</td>
                  <td class="text-sm-left">
                    <v-chip
                      :color="props.item.checkCase == 'NO' ? 'red' : 'green'"
                      label
                      small
                      text-color="white"
                    >
                      {{
                        props.item.checkCase == 'NO' ? 'SIN VALIJA' : 'LISTO'
                      }}
                    </v-chip>
                  </td>
                  <td class="text-sm-center">
                    <v-btn @click="handleDetails(props.item)" color="info"
                      >detalles</v-btn
                    >
                  </td>
                  <td class="text-sm-center">
                    <v-btn
                      @click="handleComment(props.item)"
                      color="error"
                      text
                      v-if="props.item.liquidated == 'YES'"
                      >recibo</v-btn
                    >
                  </td>
                  <td class="text-sm-center">
                    <v-badge
                      :color="props.item.liquidated == 'YES' ? 'green' : 'grey'"
                      overlap
                    >
                      <span slot="badge">&nbsp;</span>
                    </v-badge>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              :total-visible="7"
              @input="asyncPagination"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
      <message
        :key="dialog.key"
        :options="dialog"
        v-on:close="dialog.show = false"
      ></message>
    </v-dialog>

    <v-dialog max-width="1024" v-if="detail.data" v-model="detail.show">
      <compose
        :item="detail.data"
        :key="detail.key"
        v-on:close-detail="detail.show = false"
      ></compose>
    </v-dialog>

    <v-dialog max-width="500" v-if="payment.data" v-model="payment.show">
      <payment
        :item="payment.data"
        :key="payment.key"
        v-on:close-payment="payment.show = false"
        v-on:save-payment="savePayment"
      ></payment>
    </v-dialog>

    <v-dialog
      max-width="500"
      v-if="information.data"
      v-model="information.show"
    >
      <information
        :item="information.data"
        :key="information.key"
        v-on:close-information="information.show = false"
      ></information>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import compose from './../dialog/DialogDetails'
import loading from './../dialog/DialogLoading'
import payment from './../dialog/DialogPayment'
import information from './../dialog/DialogInformation'
import message from './../dialog/Message'
import search from './Search.vue'
import SessionHelper from '@/helpers/SessionHelper'

export default {
  components: {
    compose,
    loading,
    payment,
    information,
    message,
    search,
  },
  data() {
    return {
      loading: true,
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      detail: {
        show: null,
        data: null,
        key: 0,
      },
      dialog: {
        show: null,
        key: 0,
      },
      information: {
        show: null,
        data: null,
        key: 0,
      },
      payment: {
        show: null,
        data: null,
        key: 0,
      },
      form: {
        sendEmails: false,
        invoices: [],
      },
      complex: {
        selected: [],
        headers: [
          {
            text: '',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Facturas',
            sortable: false,
            value: 'invoiceNumber',
            align: 'left',
          },
          {
            text: 'Estado',
            sortable: false,
            value: 'checkCase',
            align: 'left',
          },
          {
            text: 'Detalles',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Recibo',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Pagos',

            value: 'liquidated',
            sortable: false,
            align: 'center',
          },
        ],
      },
    }
  },
  watch: {
    'complex.selected': function(val) {
      if (val) {
        this.form.invoices = []
        Object.keys(val).map(objectKey => {
          this.form.invoices.push(val[objectKey].id)
        })
      }
    },
  },
  created() {
    this.asyncPagination()
  },
  computed: {
    ...mapState({
      invoices: state => state.transit.payment,
    }),
  },
  methods: {
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true
      const filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        status: 'payment',
        ...this.pagination.search,
      }
      return new Promise(resolve => {
        this.$store.dispatch('transit/getAll', filter).then(response => {
          this.helperPaginate(response)
          return resolve()
        })
      })
    },

    handlePayment() {
      if (this.form.invoices.length > 0) {
        this.payment = {
          data: { ...this.form },
          show: true,
          key: this.payment.key + 1,
        }
      }
    },
    handleDetails(row) {
      this.loading = true
      this.$store
        .dispatch('invoices/getItems', { invoiceId: row.id })
        .then(items => {
          this.loading = false
          this.detail = {
            data: { ...row, products: items ? items : null },
            show: true,
            key: this.detail.key + 1,
          }
        })
    },

    savePayment() {
      this.payment.show = false
      this.loading = true
      this.complex.selected = []

      this.asyncPagination().then(() => {
        this.dialog = {
          message: 'Las facturas seleccionadas fueron pagadas',
          show: true,
          key: this.dialog.key + 1,
        }
      })
    },

    handleComment(row) {
      this.information = {
        data: { type: 'payment', ...row },
        show: true,
        key: this.information + 1,
      }
    },
    onSearch(params) {
      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        status: 'payment',
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
  },
}
</script>
